import React from 'react'

export default function Footer() {
    return (
        <div className="mt-24 w-full relative text-white flex flex-col bg-realblack pt-24">
            <p className="text-center tracking-wider text-5xl">Let's work together.</p>
            <p className="text-slightgray tracking-wider mt-4 text-center">I'm available for freelance work.</p>
            <div className="flex m-auto flex-col">
                <a href="https://t.me/un_like" className="btnHoverAnim btnHoverAnim-dark mt-4 cursor-pointer uppercase font-bold"> <div></div> <p className="flex mr-5 text-base items-center">Say hello <img className="w-14 ml-5" src="arrow4-dark.svg" alt="arrow" /></p></a>
            </div>
            <div className="mt-40 mb-8 p-0">
                <p className="text-center">© Leonov Svyatoslav {new Date().getFullYear()}. All rights reserved</p>
            </div>
            <div style={{background: "#f8f8f8"}} className="absolute w-6 h-6 md:w-20 md:h-20 bottom-0 left-0"></div>
        </div>
    )
}
